export default __webpack_public_path__ + "static/0304-68333f004479e89035af4aa37f80b291.png";